import classnames from 'classnames/bind'
import { TPreference } from '@/types/preference-tag'
// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type BarItemProps = {
  handleItemClick: (data: TPreference) => void
  isActive: boolean
} & TPreference

const BarItem = ({ tagName, preferenceTag, handleItemClick = () => {}, isActive }: BarItemProps) => {
  return (
    <div className={cx('bar-item', { isActive })} onClick={() => handleItemClick({ tagName, preferenceTag })}>
      <p className={cx('bar-item-text')}>{tagName}</p>
    </div>
  )
}
export default BarItem
